import axios from 'axios';

const token = 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIxIiwidW5pcXVlX25hbWUiOiJzdXBlci5hZG1pbkBnbWFpbC5jb20iLCJuYmYiOjE3NDU4NTYyNjksImV4cCI6MTc0NjExNTQ2OSwiaWF0IjoxNzQ1ODU2MjY5fQ.gBqhHHprBygcRhYZ-wRWk4EHFeDNHDfaOIWXZ55En0tB9ixHGlcWhFHwkVegIEFdHxkCaoARXNXCV4l_zc8T9Q'

const api = axios.create({
  baseURL: 'https://your-api-url.com/api', // ✅ Set your base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Optional: Add interceptors if you want
api.interceptors.request.use(
  (config) => {
    // You can add token here if needed
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
